import { useSelector } from "react-redux";
import ArchiveCarItem from "../ArchiveCarItem/ArchiveCarItem";
import styles from "./ArchiveList.module.css";
import { useState, useRef, useEffect } from "react";
import { selectError, selectLoading } from "../../../redux/archive/selectors";
import LoaderSvg from "../../Loader/LoaderSvg.jsx";

export default function ArchiveList({ carsDataArchive }) {
  const [visiblePopovers, setVisiblePopovers] = useState({});
  const [scrollHeight, setScrollHeight] = useState(705);
  const [itemHeight, setItemHeight] = useState(48);
  const scrollWrapperRef = useRef(null);
  const itemRefs = useRef([]);

  const loading = useSelector(selectLoading);
  const err = useSelector(selectError);
  const is404 = err?.status === 404;

  useEffect(() => {
    const updateSizes = () => {
      if (scrollWrapperRef.current) {
        setScrollHeight(scrollWrapperRef.current.clientHeight);
      }
      if (itemRefs.current.length > 0) {
        setItemHeight(
          itemRefs.current[0]?.getBoundingClientRect().height || 48
        );
      }
    };

    updateSizes();
    window.addEventListener("resize", updateSizes);

    return () => window.removeEventListener("resize", updateSizes);
  }, []);

  const togglePopover = (popoverName, id, index) => {
    setVisiblePopovers(prevState => {
      const newState = { ...prevState };
      const popoverKey = `${popoverName}-${id}`;
      newState[popoverKey] = !newState[popoverKey];

      Object.keys(newState).forEach(key => {
        if (key !== popoverKey) newState[key] = false;
      });

      const element = itemRefs.current[index];
      if (!element || !scrollWrapperRef.current) return newState;

      const elementOffset = element.offsetTop;
      const elementBottom = elementOffset + itemHeight;
      const visibleAreaTop = scrollWrapperRef.current.scrollTop;
      const visibleAreaBottom = visibleAreaTop + scrollHeight;

      if (elementBottom > visibleAreaBottom) {
        setTimeout(() => {
          scrollWrapperRef.current.scrollTo({
            top: elementOffset + itemHeight - scrollHeight + 20,
            behavior: "smooth",
          });
        }, 100);
      }

      return newState;
    });
  };
  return loading ? (
    <LoaderSvg />
  ) : (
    <>
      <div className={styles.listContainer}>
        <div ref={scrollWrapperRef} className={styles.scrollWrapper}>
          <ul className={styles.archiveList}>
            {is404 || !carsDataArchive?.length ? (
              <p className={styles.message}>Записів у архіві не знайдено</p>
            ) : (
              carsDataArchive.map((item, index) => (
                <li
                  key={`${item.id}-${item.vehicle?.plate}-${item.archived_at}`}
                  ref={el => (itemRefs.current[index] = el)}
                >
                  <ArchiveCarItem
                    id={item.id}
                    visiblePopovers={visiblePopovers}
                    togglePopover={popoverName =>
                      togglePopover(popoverName, item.id, index)
                    }
                  />
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </>
  );
}
